export default __webpack_public_path__ + "static/media/male.5515e236.png";